import { useSelector } from 'react-redux'
import { memo } from 'react'
import { aiVideoSelectors } from 'store/features/aiVideo/selectors'
import * as Styled from './styled'
import { COLORS } from 'consts/colors'
import { THUNDER_ICON } from 'consts/mediaUrls'
import Tooltip from 'components/Tooltip'

import { CrownIcon } from 'containers/SubSidebar/styled'
import VideoGenerationCredits from './Credits'
import { useGenerateAction } from 'hooks/useGenerateVideo'
import { isSmartEditModeSelector } from 'store/selectors'

interface IFooterProps {
  isGenerateDisabled?: boolean
}

const Footer = (props: IFooterProps) => {
  const { isGenerateDisabled } = props

  const isGenerateButtonActive = useSelector(
    aiVideoSelectors.isGenerateButtonActive
  )
  const isRequestingGeneration = useSelector(
    aiVideoSelectors.isRequestingGeneration
  )
  const isSmartEditMode = useSelector(isSmartEditModeSelector)
  const smartPrompt = useSelector(aiVideoSelectors.smartPrompt)
  const isSmartEditDisabled = isSmartEditMode && !smartPrompt

  const {
    handleGenerate,
    generateButtonLabel,
    tooltipText,
    hasInsufficientCredits,
    generationCredits,
    isApproximateCost
  } = useGenerateAction()

  const isEffectivelyDisabled = isGenerateDisabled || isSmartEditDisabled
  const isButtonDisabled =
    (!isGenerateButtonActive || isEffectivelyDisabled) &&
    !hasInsufficientCredits
  const isTooltipVisible =
    ((!isGenerateButtonActive && !isRequestingGeneration) ||
      isEffectivelyDisabled) &&
    !hasInsufficientCredits

  return (
    <Styled.Footer>
      <Tooltip
        tooltipText={isTooltipVisible ? tooltipText : ''}
        isVisible={isTooltipVisible}
      >
        <div>
          <Styled.GenerateButton
            isDisabled={isButtonDisabled}
            onClick={handleGenerate}
            $isPremium={hasInsufficientCredits}
          >
            {hasInsufficientCredits && <CrownIcon />}
            <Styled.SpinningLoaderWrapper
              size={16}
              loaderColor={COLORS.white}
              $isVisible={isRequestingGeneration}
            />
            {generateButtonLabel}
            <Styled.CreditsBadge>
              <Styled.ThunderIcon src={THUNDER_ICON} alt="credits" />
              {isApproximateCost ? `~${generationCredits}` : generationCredits}
            </Styled.CreditsBadge>
          </Styled.GenerateButton>
        </div>
      </Tooltip>
      <VideoGenerationCredits />
    </Styled.Footer>
  )
}

export default memo(Footer)
